import React, { Component } from 'react';
import { translate } from 'react-i18next';
import transferConfirmation from '../../img/transfer-confirmation.svg';
import lastOperationsIcon from '../../img/last-operations-icon.png';
import { newRequest } from '../../../../config';
import Loading from '../../Loading/Loading';
import { getFormatedDate } from '../../../../helpers/fotmatDate';
import { Switch } from '@mui/joy';
// import YesNoModal from "../../../../copms/Modals/YesNoModal/YesNoModal";

class CardSubscriptions extends Component {
    state = {
        status: 1,
        currentPage: 1,
        lastPage: 0,
        merchants: [],
        checked: false,
    }

    // selectPage(e, page) {
    //     e.preventDefault();
    //     this.setState({ currentPage: page }, () => this.getHistory())
    // }

    componentDidMount() {
        this.getPayload();
    }

    getPayload = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getSubscriptionsRequestBody = {
            cardId: this.props.match.params.id
        }
        fetch(newRequest("visa/api/vsm/subscriptions", getSubscriptionsRequestBody))
            .then(res => res.text())
            .then((getSubscriptionsResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getSubscriptionsResponse = JSON.parse(getSubscriptionsResponseJSON);
                if (getSubscriptionsResponse.status.statusCode != 1) {
                    if (getSubscriptionsResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getSubscriptionsResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                        // this.setState({ isLoading: false });
                    }
                }
                else {
                    this.setState({ merchants: [...getSubscriptionsResponse.activeMerchants, ...getSubscriptionsResponse.disabledMerchants]  || [] });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    setSubscription = (disabled, merchantName, stopInstructionId, mrchRef) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let requestBody = { merchantName, cardId: this.props.match.params.id, stopInstructionId, mrchRef }
        fetch(newRequest(`visa/api/vsm/${disabled ? 'enable' : 'disable'}`, requestBody))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(response.status.statusCode), null, null, this.getPayload);
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    render() {
        let { merchants } = this.state;
        let { t } = this.props;
        return (
            <>
                {/* <YesNoModal open={open} title={t('Are you sure you want to delete the operation?')} onClose={() => this.setState({ open: false })} triggerFunc={(bool) => bool ? this.deleteSalaryOrder(item.id, item.serviceId) : this.setState({ open: false })} /> */}
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Card subscriptions')}</h2>
                    </div>
                </div>
                <div className="dashboard-salary-container">
                    <div className="dashboard-salary-container-data-section" style={{ marginTop: '1px', width: '70%' }}>
                        <div className="dashboard-salary-order-container">
                            {merchants.length === 0 ?
                                <div className="dashboard-last-operations-section-content" style={{ minHeight: '70vh', justifyContent: 'center' }}>
                                    <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                    <p className="dashboard-last-operations-section-content-status">{t('you do not currently have any active transactions')}</p>
                                </div>
                                : <>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>{t("Subscription name")}</th>
                                                <th>{t("Amount")}</th>
                                                <th>{t("currency")}</th>
                                                <th>{t("Last payment date")}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {merchants.map(item => (
                                                <tr>
                                                    <td>{item.merchantName}</td>
                                                    <td>{item.lastTranAmt}</td>
                                                    <td>{item.lastTranCurrency}</td>
                                                    <td>{getFormatedDate(item.lastTranDateTime, "dd.mm.yyyy")}</td>
                                                    <td>
                                                        <Switch size="lg" checked={!item.disabled} onChange={() => this.setSubscription(item.disabled, item.merchantName, item.stopInstructionId, item.mrchRef)} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {/* <div style={{ width: '100%', marginTop: '15px', marginBottom: '15px', display: 'flex', justifyContent: 'center' }}>
                                        <ul className="dashboard-pagination">
                                            {this.state.currentPage != 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage - 1)}>{t('previous-page')}</a></li>}
                                            {
                                                Array.from({ length: this.state.lastPage }).map((item, index) => {
                                                    if (this.state.lastPage > 3) {
                                                        if (this.state.currentPage - 1 == index + 1) {
                                                            return (
                                                                <>
                                                                    {this.state.currentPage > 2 && <li><a href="#" onClick={(e) => this.selectPage(e, 1)}>1</a></li>}

                                                                    {this.state.currentPage > 3 && <li><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}
                                                                    <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                                </>
                                                            )
                                                        }
                                                        if (this.state.currentPage == index + 1) {
                                                            return (
                                                                <>
                                                                    <li className="active" ><a href="#" style={{ cursor: 'default' }} onClick={e => e.preventDefault()}>{index + 1}</a></li>
                                                                </>
                                                            )
                                                        }
                                                        if (this.state.currentPage + 1 == index + 1) {
                                                            return (
                                                                <>
                                                                    <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                                    {this.state.currentPage < this.state.lastPage - 2 && <li ><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}

                                                                    {this.state.currentPage + 1 < this.state.lastPage && <li ><a href="#" onClick={(e) => this.selectPage(e, this.state.lastPage)}>{this.state.lastPage}</a></li>}
                                                                </>
                                                            )
                                                        }
                                                    } else {
                                                        return (
                                                            <li className={index + 1 == this.state.currentPage ? "active" : ""}><a href="#" style={this.state.lastPage == 1 ? { borderRadius: '5px' } : {}} onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                        )
                                                    }
                                                })

                                            }
                                            {this.state.currentPage != this.state.lastPage && this.state.lastPage > 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage + 1)}>{t('next-page')}</a></li>}
                                        </ul>
                                    </div> */}
                                </>
                            }
                        </div>
                    </div>
                    <div className="dashboard-payment-container-confirmation-section">
                        <div className="dashboard-payment-container-confirmation-section-header">
                            <h3 className="dashboard-payment-container-confirmation-section-header-title">{t('Visa Subscription Manager')}</h3>
                        </div>
                        <div className="dashboard-payment-container-confirmation-section-content">
                            <img src={transferConfirmation} className="dashboard-payment-container-confirmation-section-content-image" alt="transferConfirmation" />
                            <div className="dashboard-payment-container-confirmation-section-content-description">
                                {t('vsps text')}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default translate("translation")(CardSubscriptions);